import { Col, Row, Table } from "react-bootstrap";
import { Card } from "../components/Card";
import { useFeatureFlag } from "../hooks/use-app-metadata";
import { MetaAdsRoleManager } from "../meta-ads/MetaAdsRoleManager";
import { useMetaAds } from "./useIntegrations";
import { useYouTubeOverview } from "./useYouTubeOverview";

export const TabTeamAccess = () => {
	const isYouTubeEnabled = useFeatureFlag("YouTubeIntegration");
	const isMetaAdsEnabled = useFeatureFlag("MetaAdsIntegration");
	const youtubeOverview = useYouTubeOverview(isYouTubeEnabled);
	const { status: metaAdsStatus } = useMetaAds();

	return (
		<Row>
			<Col xs={12}>
				<h2 className="mb-4">Team & clients</h2>
				<p>
					See YouTube connections across clients and assign Meta Ads roles
					without mixing them into the Applications connect list.
				</p>
			</Col>
			{isYouTubeEnabled && (
				<Col xs={12} className="mb-4">
					<Card>
						<Card.Header>YouTube — All clients</Card.Header>
						<Card.Body style={{ padding: 0, overflowX: "auto" }}>
							{youtubeOverview.isLoading ? (
								<p
									className="text-muted"
									style={{ padding: 16, marginBottom: 0 }}
								>
									Loading YouTube clients...
								</p>
							) : youtubeOverview.data && youtubeOverview.data.length > 0 ? (
								<Table size="sm" responsive className="mb-0">
									<thead>
										<tr>
											<th>Client</th>
											<th>Status</th>
											<th>Channel</th>
										</tr>
									</thead>
									<tbody>
										{youtubeOverview.data.map((item) => (
											<tr key={item.companyId}>
												<td>{item.companyName}</td>
												<td>
													{item.connectionStatus === "connected"
														? "Connected"
														: item.connectionStatus === "token_expired"
															? "Token expired"
															: "Not connected"}
												</td>
												<td>{item.channelName ?? "—"}</td>
											</tr>
										))}
									</tbody>
								</Table>
							) : (
								<p
									className="text-muted"
									style={{ padding: 16, marginBottom: 0 }}
								>
									No YouTube client connections to show yet.
								</p>
							)}
						</Card.Body>
					</Card>
				</Col>
			)}
			{isMetaAdsEnabled && (
				<Col xs={12}>
					<h3 style={{ marginBottom: 12 }}>Meta Ads team access</h3>
					<p className="text-muted" style={{ marginBottom: 16 }}>
						Assign Viewer, Editor, or Manager roles for this client&apos;s Meta
						Ads. Managers can manage connections and roles.
					</p>
					{metaAdsStatus.data.connected ? (
						<MetaAdsRoleManager />
					) : (
						<p className="text-muted">
							Connect Meta Ads in Applications to assign team roles for this
							client.
						</p>
					)}
				</Col>
			)}
		</Row>
	);
};
